export function initLessonSwitcher() {
  const lessons = document.querySelectorAll('[data-lesson-type]');
  const contentPanels = document.querySelectorAll('[data-content-type]');

  if (!lessons.length || !contentPanels.length) return;

  lessons.forEach(lesson => {
    lesson.addEventListener('click', e => {
      e.preventDefault();
      const type = lesson.dataset.lessonType;

      contentPanels.forEach(panel => {
        if (panel.dataset.contentType === type) {
          panel.classList.remove('hidden');
        } else {
          panel.classList.add('hidden');
        }
      });

      lessons.forEach(l => {
        l.classList.remove('lesson-active', 'bg-dcco-secondary/10', 'dark:bg-white/10', 'border-s-2', 'border-dcco-secondary');
      });
      lesson.classList.add('lesson-active', 'bg-dcco-secondary/10', 'dark:bg-white/10', 'border-s-2', 'border-dcco-secondary');

      const panel = document.querySelector('[data-curriculum-panel]');
      if (panel && window.innerWidth < 1024) {
        closeOverlay(panel);
      }
    });
  });

  initCurriculumToggle();
  initNotesToggle();
}

function openOverlay(panel, position) {
  panel.classList.remove('hidden');
  panel.classList.add('flex', position === 'start' ? 'panel-overlay-start' : 'panel-overlay-end');
  const backdrop = panel.previousElementSibling;
  if (backdrop && backdrop.hasAttribute('data-curriculum-backdrop') || backdrop && backdrop.hasAttribute('data-notes-backdrop')) {
    backdrop.classList.remove('hidden');
  }
}

function closeOverlay(panel) {
  panel.classList.add('hidden');
  panel.classList.remove('flex', 'lg:flex', 'xl:flex', 'panel-overlay-start', 'panel-overlay-end');
  const backdrop = panel.previousElementSibling;
  if (backdrop) backdrop.classList.add('hidden');
}

function resetOverlay(panel) {
  panel.classList.remove('panel-overlay-start', 'panel-overlay-end');
}

function initCurriculumToggle() {
  const toggleBtns = document.querySelectorAll('[data-curriculum-toggle]');
  const panel = document.querySelector('[data-curriculum-panel]');
  if (!toggleBtns.length || !panel) return;

  let backdrop = document.querySelector('[data-curriculum-backdrop]');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.setAttribute('data-curriculum-backdrop', '');
    backdrop.className = 'fixed inset-0 bg-black/40 backdrop-blur-sm z-30 hidden';
    panel.parentNode.insertBefore(backdrop, panel);
  }

  let isOpen = window.innerWidth >= 1024;

  function open() {
    isOpen = true;
    panel.classList.remove('hidden', 'lg:flex');
    panel.classList.add('flex');
    if (window.innerWidth < 1024) {
      panel.classList.add('panel-overlay-start');
      backdrop.classList.remove('hidden');
    }
  }

  function close() {
    isOpen = false;
    panel.classList.add('hidden');
    panel.classList.remove('flex', 'lg:flex', 'panel-overlay-start');
    backdrop.classList.add('hidden');
  }

  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (isOpen) close(); else open();
    });
  });

  backdrop.addEventListener('click', close);

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024) {
      resetOverlay(panel);
      backdrop.classList.add('hidden');
      if (!isOpen) open();
    }
  });
}

function initNotesToggle() {
  const toggleBtns = document.querySelectorAll('[data-notes-toggle]');
  const panel = document.querySelector('[data-notes-panel]');
  if (!toggleBtns.length || !panel) return;

  let backdrop = document.querySelector('[data-notes-backdrop]');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.setAttribute('data-notes-backdrop', '');
    backdrop.className = 'fixed inset-0 bg-black/40 backdrop-blur-sm z-30 hidden';
    panel.parentNode.insertBefore(backdrop, panel);
  }

  function open() {
    panel.classList.remove('hidden', 'xl:flex');
    panel.classList.add('flex', 'panel-overlay-end');
    backdrop.classList.remove('hidden');
  }

  function close() {
    panel.classList.add('hidden');
    panel.classList.remove('flex', 'xl:flex', 'panel-overlay-end');
    backdrop.classList.add('hidden');
  }

  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const isVisible = panel.classList.contains('panel-overlay-end');
      if (isVisible) close(); else open();
    });
  });

  backdrop.addEventListener('click', close);

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1280) {
      resetOverlay(panel);
      backdrop.classList.add('hidden');
    }
  });
}
